module.exports = __webpack_public_path__ + "static/media/hr.d1381487.svg";